export default "__VITE_ASSET__CRJ4TZah__"